export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "UU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "NU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "UU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "NU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "NU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "NU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "NU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "NU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "NU",
	},
	pichu: {
		tier: "LC",
	},
	pichuspikyeared: {
		tier: "NU",
	},
	pikachu: {
		tier: "NU",
	},
	raichu: {
		tier: "NU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "NU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "NU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "UU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		tier: "UU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "NU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "NU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NU",
	},
	crobat: {
		tier: "UUBL",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "NU",
	},
	bellossom: {
		tier: "NU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "NU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "NU",
	},
	diglett: {
		tier: "NU",
	},
	dugtrio: {
		tier: "UU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "NU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "NU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "UU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "UU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "NU",
	},
	politoed: {
		tier: "NU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NU",
	},
	alakazam: {
		tier: "UU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NU",
	},
	machamp: {
		tier: "OU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "NU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "(OU)",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		tier: "NU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "NU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "UU",
	},
	slowking: {
		tier: "NU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "NU",
	},
	magnezone: {
		tier: "OU",
	},
	farfetchd: {
		tier: "NU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "NU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "NU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		tier: "NU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "UU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NU",
	},
	gengar: {
		tier: "OU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "UU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "NU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "NU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "NU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "UU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "NU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "UU",
	},
	hitmonchan: {
		tier: "NU",
	},
	hitmontop: {
		tier: "UU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		tier: "NU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "UU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "NFE",
	},
	rhyperior: {
		tier: "UU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "UU",
	},
	blissey: {
		tier: "OU",
	},
	tangela: {
		tier: "NU",
	},
	tangrowth: {
		tier: "UU",
	},
	kangaskhan: {
		tier: "UU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "OU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "NU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		tier: "NU",
	},
	scyther: {
		tier: "UU",
	},
	scizor: {
		tier: "OU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "NU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NU",
	},
	electivire: {
		tier: "(OU)",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		tier: "NU",
	},
	pinsir: {
		tier: "NU",
	},
	tauros: {
		tier: "NU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "OU",
	},
	lapras: {
		tier: "NU",
	},
	ditto: {
		tier: "NU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "(OU)",
	},
	jolteon: {
		tier: "(OU)",
	},
	flareon: {
		tier: "NU",
	},
	espeon: {
		tier: "NUBL",
	},
	umbreon: {
		tier: "(OU)",
	},
	leafeon: {
		tier: "UU",
	},
	glaceon: {
		tier: "NU",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		tier: "NU",
	},
	porygonz: {
		tier: "UUBL",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "UU",
	},
	aerodactyl: {
		tier: "OU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		tier: "(OU)",
	},
	articuno: {
		tier: "NU",
	},
	zapdos: {
		tier: "OU",
	},
	moltres: {
		tier: "UU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NU",
	},
	dragonite: {
		tier: "OU",
	},
	mewtwo: {
		tier: "Uber",
	},
	mew: {
		tier: "Uber",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		tier: "NU",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		tier: "NU",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		tier: "UU",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "NU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "NU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "NU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "NU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		tier: "UU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NU",
	},
	togekiss: {
		tier: "(OU)",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "NU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		tier: "NU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "UU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "NU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "NU",
	},
	aipom: {
		tier: "LC",
	},
	ambipom: {
		tier: "UU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "NU",
	},
	yanma: {
		tier: "NU",
	},
	yanmega: {
		tier: "UUBL",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "NU",
	},
	murkrow: {
		tier: "NU",
	},
	honchkrow: {
		tier: "UUBL",
	},
	misdreavus: {
		tier: "NU",
	},
	mismagius: {
		tier: "UU",
	},
	unown: {
		tier: "NU",
	},
	wynaut: {
		tier: "Uber",
	},
	wobbuffet: {
		tier: "Uber",
	},
	girafarig: {
		tier: "NU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "OU",
	},
	dunsparce: {
		tier: "NU",
	},
	gligar: {
		tier: "NU",
		doublesTier: "LC",
	},
	gliscor: {
		tier: "OU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "NU",
	},
	qwilfish: {
		tier: "UU",
	},
	shuckle: {
		tier: "NU",
	},
	heracross: {
		tier: "UUBL",
	},
	sneasel: {
		tier: "NU",
	},
	weavile: {
		tier: "OU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "UU",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "NU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NU",
	},
	mamoswine: {
		tier: "(OU)",
	},
	corsola: {
		tier: "NU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "NU",
	},
	delibird: {
		tier: "NU",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		tier: "NU",
	},
	skarmory: {
		tier: "OU",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		tier: "UU",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UU",
	},
	stantler: {
		tier: "NU",
	},
	smeargle: {
		tier: "(OU)",
	},
	miltank: {
		tier: "UU",
	},
	raikou: {
		tier: "UUBL",
	},
	entei: {
		tier: "NUBL",
	},
	suicune: {
		tier: "OU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "OU",
	},
	lugia: {
		tier: "Uber",
	},
	hooh: {
		tier: "Uber",
	},
	celebi: {
		tier: "OU",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		tier: "UU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		tier: "UU",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		tier: "OU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "NU",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		tier: "NU",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		tier: "NU",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		tier: "NU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		tier: "UU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "NU",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		tier: "UU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "NU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "NU",
	},
	gallade: {
		tier: "UUBL",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "NU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "OU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "NU",
	},
	slaking: {
		tier: "NU",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "(OU)",
	},
	shedinja: {
		tier: "NU",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "NU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "UU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		tier: "NU",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		tier: "NU",
	},
	sableye: {
		tier: "NU",
	},
	mawile: {
		tier: "NU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		tier: "UU",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		tier: "NU",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "NU",
	},
	plusle: {
		tier: "NU",
	},
	minun: {
		tier: "NU",
	},
	volbeat: {
		tier: "NU",
	},
	illumise: {
		tier: "NU",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "NU",
	},
	roserade: {
		tier: "OU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "NU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "NU",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "NU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "NU",
	},
	torkoal: {
		tier: "NU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		tier: "NU",
	},
	spinda: {
		tier: "NU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		tier: "OU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "NU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "UU",
	},
	zangoose: {
		tier: "NU",
	},
	seviper: {
		tier: "NU",
	},
	lunatone: {
		tier: "NU",
	},
	solrock: {
		tier: "NU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "NU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "NU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "UU",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		tier: "NU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		tier: "NU",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "UU",
	},
	castform: {
		tier: "NU",
	},
	castformsunny: {},
	castformrainy: {},
	castformsnowy: {},
	kecleon: {
		tier: "NU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		tier: "NU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NU",
	},
	dusknoir: {
		tier: "(OU)",
	},
	tropius: {
		tier: "NU",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		tier: "NU",
	},
	absol: {
		tier: "UU",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "NU",
	},
	froslass: {
		tier: "UUBL",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		tier: "NU",
	},
	clamperl: {
		tier: "NU",
	},
	huntail: {
		tier: "NU",
	},
	gorebyss: {
		tier: "NU",
	},
	relicanth: {
		tier: "NU",
	},
	luvdisc: {
		tier: "NU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NU",
	},
	salamence: {
		tier: "Uber",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NU",
	},
	metagross: {
		tier: "OU",
	},
	regirock: {
		tier: "NU",
	},
	regice: {
		tier: "NU",
	},
	registeel: {
		tier: "UU",
	},
	latias: {
		tier: "OU",
	},
	latios: {
		tier: "Uber",
	},
	kyogre: {
		tier: "Uber",
	},
	groudon: {
		tier: "Uber",
	},
	rayquaza: {
		tier: "Uber",
	},
	jirachi: {
		tier: "OU",
	},
	deoxys: {
		tier: "Uber",
	},
	deoxysattack: {
		tier: "Uber",
	},
	deoxysdefense: {
		tier: "Uber",
	},
	deoxysspeed: {
		tier: "Uber",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		tier: "UU",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "NU",
	},
	infernape: {
		tier: "OU",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		tier: "OU",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		tier: "UUBL",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		tier: "NU",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		tier: "NU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "NU",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		tier: "NU",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		tier: "NU",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		tier: "NU",
	},
	wormadamsandy: {
		tier: "NU",
	},
	wormadamtrash: {
		tier: "NU",
	},
	mothim: {
		tier: "NU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "NU",
	},
	pachirisu: {
		tier: "NU",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		tier: "NU",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		tier: "NU",
	},
	cherrimsunshine: {
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "NU",
	},
	drifloon: {
		tier: "LC",
	},
	drifblim: {
		tier: "NU",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		tier: "NU",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		tier: "NU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "NU",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		tier: "OU",
	},
	chatot: {
		tier: "NU",
	},
	spiritomb: {
		tier: "UU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NU",
	},
	garchomp: {
		tier: "Uber",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "OU",
	},
	hippopotas: {
		tier: "NUBL",
	},
	hippowdon: {
		tier: "OU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		tier: "UU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "UU",
	},
	carnivine: {
		tier: "NU",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		tier: "NU",
	},
	snover: {
		tier: "NUBL",
	},
	abomasnow: {
		tier: "UUBL",
	},
	rotom: {
		tier: "UU",
	},
	rotomheat: {
		tier: "OU",
	},
	rotomwash: {
		tier: "OU",
	},
	rotomfrost: {
		tier: "OU",
	},
	rotomfan: {
		tier: "OU",
	},
	rotommow: {
		tier: "OU",
	},
	uxie: {
		tier: "UU",
	},
	mesprit: {
		tier: "UU",
	},
	azelf: {
		tier: "OU",
	},
	dialga: {
		tier: "Uber",
	},
	palkia: {
		tier: "Uber",
	},
	heatran: {
		tier: "OU",
	},
	regigigas: {
		tier: "NU",
	},
	giratina: {
		tier: "Uber",
	},
	giratinaorigin: {
	},
	cresselia: {
		tier: "UUBL",
	},
	phione: {
		tier: "NU",
	},
	manaphy: {
		tier: "Uber",
	},
	darkrai: {
		tier: "Uber",
	},
	shaymin: {
		tier: "(OU)",
	},
	shayminsky: {
		tier: "Uber",
	},
	arceus: {
		tier: "AG",
	},
	arceusbug: {
	},
	arceusdark: {
	},
	arceusdragon: {
	},
	arceuselectric: {
	},
	arceusfighting: {
	},
	arceusfire: {
	},
	arceusflying: {
	},
	arceusghost: {
	},
	arceusgrass: {
	},
	arceusground: {
	},
	arceusice: {
	},
	arceuspoison: {
	},
	arceuspsychic: {
	},
	arceusrock: {
	},
	arceussteel: {
	},
	arceuswater: {
	},
};
